import styled from "styled-components";

export const LanguageRow = styled.div`
    display: flex;
    justify-content: flex-end;
`;
